import { Button, DataSource, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutTractorListToolPanel extends Layout {
    buttonSeatTractor: Button;
    panel1: Panel;
    panelButtons: Panel;
    panelToolLeft: Panel;
    panelToolRight: Panel;
    sourceTractor: DataSource;
}
